export const partnersSection = {
  title: 'Партнери',
  description:
    "Ми прагнемо стати лідерами, працюючи лише з надійними та перевіреними партнерами з відомим ім'ям. Кожен наш вибір ґрунтується на високих стандартах якості та професіоналізму, щоб надати нашим клієнтам тільки найкраще зі світу інновацій. Ми віримо, що тільки взаємовигідна і чесна співпраця з нашими партнерами допоможе вам стати власником будинку вашої мрії.",
};
